import React, { useContext } from "react";

import { Navigate, useLocation } from "react-router-dom";

import { LoggedInContext } from "./authContextProvider";

type Props = {
  component: React.ReactNode;
};

// 未ログインでもアクセス可能なパス
const PUBLIC_ROUTES = ["/login", "/resetPassword"];

export const RouteAuthGuard: React.FC<Props> = (props) => {
  const [loggedIn] = useContext(LoggedInContext);
  const { pathname } = useLocation();
  // ログイン済みで公開ページにアクセスしたらtopへリダイレクトする
  if (loggedIn === true && PUBLIC_ROUTES.includes(pathname)) {
    return <Navigate to={"/"} replace={false} />;
  }
  // 未ログインで公開ページ以外にアクセスしたらloginページへ
  if (loggedIn === false && !PUBLIC_ROUTES.includes(pathname)) {
    return <Navigate to={"/login"} />;
  }
  return <>{props.component}</>;
};
